export default function Projects() {
  const projects = [
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20elevated%20highway%20and%20metro%20rail%20infrastructure%20project%20with%20concrete%20pillars%20and%20steel%20structures%20showcasing%20advanced%20urban%20transportation%20development%20against%20clear%20sky%20with%20professional%20engineering%20excellence%20and%20clean%20architectural%20lines&width=800&height=600&seq=project-vertak-001&orientation=landscape',
      title: 'Landmark Highway & Metro Projects',
      description: 'Large-scale infrastructure development connecting major urban centers with state-of-the-art transportation solutions'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Luxury%20residential%20complex%20with%20modern%20architecture%20featuring%20elegant%20glass%20facades%20contemporary%20design%20and%20landscaped%20gardens%20showcasing%20premium%20real%20estate%20development%20with%20sophisticated%20urban%20living%20spaces%20and%20high-end%20construction%20quality&width=800&height=600&seq=project-vertak-002&orientation=landscape',
      title: 'Residential Complex Developments',
      description: 'Premium residential projects combining modern design with sustainable living spaces'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20mining%20facility%20with%20advanced%20equipment%20and%20industrial%20machinery%20showcasing%20mineral%20extraction%20operations%20with%20professional%20mining%20infrastructure%20and%20technological%20innovation%20in%20natural%20resource%20development%20with%20clean%20industrial%20environment&width=800&height=600&seq=project-vertak-003&orientation=landscape',
      title: 'Mining Modernization',
      description: 'Advanced mining operations utilizing cutting-edge technology for efficient resource extraction'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20jewelry%20collection%20display%20with%20precious%20gemstones%20diamonds%20and%20gold%20ornaments%20on%20sophisticated%20velvet%20surface%20showcasing%20high-end%20craftsmanship%20and%20premium%20jewelry%20design%20with%20professional%20lighting%20and%20refined%20presentation&width=800&height=600&seq=project-vertak-004&orientation=landscape',
      title: 'Global Gems Export Partnerships',
      description: 'International trade partnerships delivering exquisite gems and jewellery to global markets'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20office%20building%20with%20contemporary%20glass%20and%20steel%20architecture%20showcasing%20corporate%20real%20estate%20development%20with%20sleek%20professional%20design%20and%20urban%20business%20district%20environment%20with%20premium%20construction%20quality&width=800&height=600&seq=project-vertak-005&orientation=landscape',
      title: 'Commercial Real Estate',
      description: 'Strategic commercial developments creating modern business hubs and retail spaces'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Large%20scale%20bridge%20construction%20project%20with%20massive%20concrete%20structures%20and%20engineering%20excellence%20showcasing%20infrastructure%20development%20with%20heavy%20construction%20equipment%20and%20professional%20civil%20engineering%20work%20in%20progress&width=800&height=600&seq=project-vertak-006&orientation=landscape',
      title: 'Bridge Engineering Excellence',
      description: 'Complex bridge projects demonstrating advanced engineering capabilities and structural innovation'
    }
  ];

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Featured Projects</h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Showcasing our commitment to excellence across diverse industries
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="w-full h-80">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-xl font-bold mb-2">{project.title}</h3>
                <p className="text-sm text-gray-200">{project.description}</p>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 bg-[#C9A961] rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-up-line text-white text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}